import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import CompanyLocationSelector from '../common/CompanyLocationSelector';
import WeatherWidget from '../common/WeatherWidget';
import { MENU_ITEMS } from '../../config/navConfig';
import { getSelectedLocation } from '../../util/locationUtils';
import ScopeService from '../../services/scopeService';

// Build route-to-label lookup from navConfig
const ROUTE_LABELS = {};
Object.values(MENU_ITEMS).forEach(item => {
  if (item.route) {
    // Use pathname only (strip query string)
    const pathname = item.route.split('?')[0];
    if (!ROUTE_LABELS[pathname]) {
      ROUTE_LABELS[pathname] = { label: item.label, icon: item.icon };
    }
  }
});


class componentName extends Component {

  getWeatherZip = () => {
    const { userType, locations, selectedLocationId } = this.props;
    if (userType === 'installer' || userType === 'technician') {
      const loc = getSelectedLocation(locations, selectedLocationId);
      if (loc) return loc.installer_address_zip || loc.address_zip || null;
      // Fallback to first location
      if (locations?.length) return locations[0].installer_address_zip || locations[0].address_zip || null;
      return null;
    }
    if (userType === 'dealer' || userType === 'dealer_group') {
      const company = ScopeService.getCompany();
      return company?.dealer_address_zip || company?.dealer_Address_Zip || null;
    }
    return null;
  };

  // Get the current page label from the route
  getCurrentPageLabel = () => {
    const pathname = this.props.location?.pathname || window.location.pathname;
    const match = ROUTE_LABELS[pathname];
    if (match) return match;
    // Try parent path (e.g. /staff/time-reports -> /staff)
    const parentPath = '/' + pathname.split('/').filter(Boolean)[0];
    return ROUTE_LABELS[parentPath] || null;
  };

  render() {
    const currentPage = this.getCurrentPageLabel();

    return (
      <React.Fragment>
        <nav className="navbar bg-white shadow-sm navbar-light mb-4 d-none d-lg-block">
          <div className="row align-items-center">
            <div className="col-md-4 d-flex align-items-center">
              <CompanyLocationSelector
                companyName={this.props.title}
                userId={this.props.userId}
                userType={this.props.userType}
                userRole={this.props.userRole}
                locations={this.props.locations}
                selectedLocationId={this.props.selectedLocationId}
                onSwitch={this.props.onSwitch}
                onLocationChange={this.props.onLocationChange}
                selectedDealerId={this.props.selectedDealerId}
                groupId={this.props.groupId}
              />
              <WeatherWidget zip={this.getWeatherZip()} />
          </div>
          <div className="col text-center">
            {currentPage && (
              <span className="text-muted" style={{ fontSize: '1.1rem' }}>
                <i className={`${currentPage.icon} mr-2`}></i>
                {currentPage.label}
              </span>
            )}
          </div>
          {this.props.userType === 'installer' && (
            <div className="col-auto d-flex align-items-center">
              <button
                className={`btn btn-outline-primary btn-sm obd-trigger ${this.props.showOBD ? 'active' : ''}`}
                onClick={this.props.onOBDToggle}
                title="OBD — On-Board Diagnostics"
              >
                <i className="fa-sharp fa-solid fa-engine-warning mr-1" />
                OBD
              </button>
            </div>
          )}
          <div className="col-md-4 text-right">
            <span className="navbar-text">{this.props.userName}</span>
          </div>
        </div>
        </nav>
      </React.Fragment>
    )
  }
}

export default withRouter(componentName);
